import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import { ConfirmDialog } from '../PrototypeShared';
import { usePrototypeAuth } from '../PrototypeAuthContext';

export default function LoginScreen() {
  const navigate = useNavigate();
  const { login } = usePrototypeAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorModal, setErrorModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorModal(true);
      return;
    }
    setSuccessModal(true);
  };

  const handleSuccessClose = () => {
    setSuccessModal(false);
    login();
    navigate('/prototype/dashboard');
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Login</Typography>
        <Typography color="text.secondary" paragraph>Prototype: submit to see success, then go to Dashboard.</Typography>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} margin="normal" />
          <TextField fullWidth label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} margin="normal" />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>Sign in</Button>
        </form>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button component={Link} to="/prototype/register" size="small">Register</Button>
          <Button component={Link} to="/prototype/operator/login" size="small">Operator login</Button>
        </Box>
      </Paper>
      <ConfirmDialog open={errorModal} title="Error" message="Please enter email and password." onConfirm={() => setErrorModal(false)} onCancel={() => setErrorModal(false)} confirmLabel="OK" />
      <ConfirmDialog open={successModal} title="Success" message="Login successful. Going to Dashboard." onConfirm={handleSuccessClose} onCancel={handleSuccessClose} confirmLabel="OK" />
    </Box>
  );
}
